import { FC, MouseEventHandler, useCallback } from "react";
import { Checkbox } from "@mui/material";
import { setSavingsOpportunitiesSelectedRowsIds } from "@/store/savings-opportunities/savingsOpportunitiesSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { savingsOpportunitiesSelectedRowsIdsSelector } from "@/store/savings-opportunities/selectors/selection/savingsOpportunitiesSelectedRowsIdsSelector";

interface ResourceDetailsOpportunityRowCheckboxColumnProps {
  opportunityId: string;
}

export const ResourceDetailsOpportunityRowCheckboxColumn: FC<
  ResourceDetailsOpportunityRowCheckboxColumnProps
> = ({ opportunityId }) => {
  const dispatch = useAppDispatch();
  const selectedRows = useAppSelector(
    savingsOpportunitiesSelectedRowsIdsSelector,
  );

  const selectHandler = useCallback(
    (_: unknown, checked: boolean) => {
      dispatch(
        setSavingsOpportunitiesSelectedRowsIds(
          checked
            ? [...selectedRows, opportunityId]
            : selectedRows.filter((id) => id !== opportunityId),
        ),
      );
    },
    [dispatch, selectedRows, opportunityId],
  );

  return (
    <Checkbox
      size="small"
      sx={{ p: 0 }}
      onClick={stopPropagation}
      onChange={selectHandler}
    />
  );
};

const stopPropagation: MouseEventHandler = (e) => e.stopPropagation();
